export const getStepState = (stepId, nextStep, steps, showSubSteps, isAlertPage) => {
  const done = stepId < nextStep
  const active = stepId === nextStep
  const block = nextStep === steps.TOP_UP ? stepId !== steps.TOP_UP : stepId > nextStep
  const isProcess =
    stepId === steps.ALERTS &&
    (showSubSteps === "bin" || showSubSteps === "arn") &&
    nextStep === steps.ALERTS
  const isSub = stepId === steps.ALERTS && isAlertPage

  return { done, active, block, isProcess, isSub }
}
